Monet.UI.Fields.GrowList = (function () {

    function GrowList () {

        this.dataSource = null;
        this.delegate = null;
        this.callBackAfterAction = null;

        var __numberOfItems = 0;
        var __addRowButton = null;
        var __cells = [];

        Monet.UI.Fields.Base.apply(this, arguments);
        this.createBaseStructure();

        this.setCallBackAfterAction = function (callback) {
            this.callBackAfterAction = callback;
        };

        this.clear = function () {

            this.rootEl.innerHTML = '';
            this.tryReallocateAddButtonToCell(null);

        };

        this.createElement = function () {

            var currentCell = null;
            var lastCell = null;

            __numberOfItems = this.dataSource.numberOfItemsForGrowList(this);
            __addRowButton = this.createAddRowButton();

            for (var index = 0; index < __numberOfItems; index++) {

                var cellElement = this.dataSource.cellForRowAtIndexForGrowList(index, this);
                var cssClass = this.dataSource.cssClassForRowAtIndexForGrowList(index, this);
                cellElement.className = cssClass;

                currentCell = new Monet.UI.Fields.GrowListCell();
                currentCell.setIndex(index);
                currentCell.setGrowList(this);
                currentCell.setContent(cellElement);

                __cells.push(currentCell);

                this.appendCell(currentCell.render());
                lastCell = currentCell;

            }

            this.tryReallocateAddButtonToCell(lastCell);

        };

        this.createAddRowButton = function () {

            var addButton = document.createElement('div');
            addButton.className = 'buttonAdd';
            addButton.innerHTML = '+';

            var addButtonListener = (function (scope) {

                return function () {

                    if (scope.delegate && scope.delegate.shouldCreateNewCell()) {

                        var cellElement = scope.delegate.createNewCell();
                        var cssClass = scope.delegate.cssClassForNewCell();
                        cellElement.className = cssClass;

                        var currentCell = new Monet.UI.Fields.GrowListCell();
                        currentCell.setIndex(__numberOfItems);
                        currentCell.setGrowList(scope);
                        currentCell.setContent(cellElement);

                        __cells.push(currentCell);
                        __numberOfItems = __cells.length;

                        scope.appendCell(currentCell.render());
                        scope.reallocateAddButtonToCell(currentCell);
                        if (scope.callBackAfterAction) {
                            scope.callBackAfterAction();
                        }

                    }

                };

            }(this));

            addButton.removeEventListener('click', addButtonListener);
            addButton.addEventListener('click', addButtonListener);

            return addButton;

        };

        this.appendCell = function (cell) {

            this.rootEl.appendChild(cell);

        };

        this.tryReallocateAddButtonToCell = function (cell) {

            if (cell) {

                this.reallocateAddButtonToCell(cell);

            } else {

                this.rootEl.appendChild(__addRowButton);

            }

        };

        this.reallocateAddButtonToCell = function (cell) {

            cell.appendUtilityView(__addRowButton);

        };

        this.cellAtIndex = function (index) {

            return __cells[index];

        };

        this.removeCellAtIndex = function (index) {

            var cellToRemove = this.cellAtIndex(index);

            if (cellToRemove) {

                this.removeCell(cellToRemove);

            }

        };

        this.removeCell = function (cellToRemove) {

            var indexToRemove = cellToRemove.getIndex();

            if (this.delegate && this.delegate.shouldRemoveCellAtIndex(cellToRemove, indexToRemove)) {

                var removedCell = __cells.splice(indexToRemove, 1)[0];
                var parentNode = cellToRemove.rootEl.parentNode;
                var lastCell;

                __numberOfItems = __cells.length;
                lastCell = __cells[__numberOfItems - 1];
                this.tryReallocateAddButtonToCell(lastCell);

                if (parentNode) {

                    parentNode.removeChild(cellToRemove.rootEl);

                }

                if (this.delegate.didRemoveCellAtIndex) {

                    this.delegate.didRemoveCellAtIndex(removedCell, indexToRemove);

                }

            }

            for (var index = 0; index < __numberOfItems; index++) {

                var cell = __cells[index];
                cell.setIndex(index);
            }

            if (this.callBackAfterAction) {
                this.callBackAfterAction();
            }

        };

        this.getNumberOfItems = function () {

            return __numberOfItems;

        };

        this.render = function () {

            this.createElement();
            return this.rootEl;

        };

    }

    return GrowList;

}());
